export enum Partner {
	AMAZON_FRESH = 'amazonFresh',
	BASKETFUL = 'basketful',
	INSTACART = 'instacart',
	KROGER = 'kroger',
	NONE = 'none',
	WALMART = 'walmart',
	TARGET = 'target',
	LOWES = 'lowes',
}

export const integratedRetailerPartnerMap: { [key: string]: Partner } = {};

Object.keys(Partner).forEach((key) => {
	integratedRetailerPartnerMap[(Partner as any)[key]] = key as Partner;
});
